module.exports = __webpack_public_path__ + "static/media/logo-아이알엠@2x.e374debd.png";